import { customAlphabet } from 'nanoid';

const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
const generate = customAlphabet(alphabet, 12);

/** Generates a short, URL-safe, collision-resistant identifier. */
export function newId(prefix?: string): string {
  return prefix ? `${prefix}_${generate()}` : generate();
}
